import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const UserBarChart = ({ data }) => {
  return (
    <div
      style={{
        width: "100%",
        height: 290,
        background: "#fff",
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h4 style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>
          Users
        </h4>

        {/* Custom Legend */}
        <div style={{ display: "flex", gap: "12px", fontSize: "12px" }}>
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span
              style={{
                width: 8,
                height: 8,
                background: "#22c55e",
                borderRadius: "50%",
              }}
            />
            Active
          </span>

          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span
              style={{
                width: 8,
                height: 8,
                background: "#d1d5db",
                borderRadius: "50%",
              }}
            />
            Inactive
          </span>
        </div>
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height="85%">
        <BarChart data={data} barGap={6}>
          <CartesianGrid stroke="#f1f5f9" vertical={false} />

          <XAxis
            dataKey="month"
            tick={{ fontSize: 11, fill: "#6b7280" }}
            axisLine={false}
            tickLine={false}
          />

          <YAxis
            tick={{ fontSize: 11, fill: "#6b7280" }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              border: "none",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          />

          {/* Inactive (background light bars) */}
          <Bar
            dataKey="inactive"
            fill="#e5e7eb"
            radius={[6, 6, 0, 0]}
            barSize={10}
          />

          {/* Active (main green bars) */}
          <Bar
            dataKey="active"
            fill="#22c55e"
            radius={[6, 6, 0, 0]}
            barSize={10}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UserBarChart;